import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Asset } from '@app/models/company/asset.model';
import { DeprecatedConfirmationDialogComponent, DeprecatedModalFormComponent } from '@app/components';
import { NotifyService, AuthService } from '@app/services';
import { AssetAssignmentTable } from '@app/modules/company/services';
import { AssetAssignment } from '@app/models/company/asset-assignment.model';

@Component({
    templateUrl: './assets-show.template.html',
    styleUrls: ['./assets-show.style.scss'],
})
export class AssetsShowView {
    @ViewChild('confirmDeleteCustomReportDialog', { static: true })
    confirmDeleteCustomReportDialog: DeprecatedConfirmationDialogComponent;
    @ViewChild('assignAssetModal', { static: true }) assignAssetModal: DeprecatedModalFormComponent;
    @ViewChild('reassignAssetModal', { static: true }) reassignAssetModal: DeprecatedModalFormComponent;

    isLoading = false;

    title: string;
    asset: Asset;
    table: AssetAssignmentTable;

    assetReassignment: AssetAssignment;

    constructor(
        public auth: AuthService,
        private route: ActivatedRoute,
        private router: Router,
        private notify: NotifyService
    ) {
        this.asset = this.route.snapshot.data.models.get('asset');
        this.title = this.asset.name;
        this.table = new AssetAssignmentTable(this.auth, this.asset);
    }

    showAssignAssetModal(): void {
        if (!this.asset.assignment) {
            this.asset.assignment = new AssetAssignment();
            this.assignAssetModal.show();
            return;
        }
        this.assetReassignment = new AssetAssignment();
        this.reassignAssetModal.show();
    }

    onAssignAsset(assetAssignment: AssetAssignment): void {
        this.isLoading = true;
        assetAssignment.assetId = this.asset.id;

        assetAssignment
            .param('asset', assetAssignment.assetId)
            .save()
            .then(() => {
                this.table.reload();
                Asset.with(['assignment', 'assignment.employee'])
                    .find(this.asset.id)
                    .then((asset: Asset) => {
                        this.asset = asset;
                    });
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'Asset could not be assigned.');
            });
    }

    onEdit(): void {
        this.router.navigate(['/company', 'assets', String(this.asset.id), 'edit'], { relativeTo: this.route });
    }

    onCancel(): void {
        if (!this.asset.assignment?.isPersisted) {
            this.asset.assignment = null;
        }
    }

    onDelete(): void {
        this.confirmDeleteCustomReportDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;
            this.asset
                .delete()
                .then(() => {
                    this.router.navigate(['/company', 'assets'], { relativeTo: this.route });
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.notify.error(err.message || 'Asset could not be deleted');
                });
        });
    }

    getAssetDeleteDialogHeader(): string {
        return `Delete ${this.asset.name}?`;
    }

    hasAssignment(): boolean {
        return this.asset.assignment && this.asset.assignment?.isPersisted;
    }
}
